import apiService from "./apiService";

const certificateService = {
    async search(keyword) {
        try {
            const resp = await apiService.get(`certificates/search`, { keyword: keyword }, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async getInfo(id) {
        try {
            const resp = await apiService.get(`certificates/${id}/get-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async save(data) {
        try {
            const resp = await apiService.post(`certificates/save`, data, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async saveToIssue(payload){
        try{
            const resp = await apiService.post(`certificates/save-to-issue`,payload,true);
            return resp.data
        }
        catch{
            return {success: false, message: "An error occured while processing the request"};
        }
    }
}

export default certificateService;